import React, { useState, useEffect } from 'react';
import Loader from '../../Search/Loader';

const RaceResultsTable = ({ race, raceSprint, permalink }) => {
    const [loading, setLoading] = useState(false);
    const [firstLoading, setFirstLoading] = useState(true);
    const [raceId, setRaceId] = useState(race);
    const [sprint, setSprint] = useState(raceSprint);
    const [racesData, setRacesData] = useState([]);
    const [racesTotal, setRacesTotal] = useState(0);
    const [viewAll, setViewAll] = useState(false);
    const [viewMore, setViewMore] = useState(false);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(100);

    const fetchRacesResults = () => {
        if (page === 1) {
            setFirstLoading(true);
        } else {
            setLoading(true);
        }

        fetch(`${wp_ajax.db_ajax_url}?action=fetch_database_race_results&race_id=${raceId}&sprint=${sprint}&page=${page}&perPage=${perPage}`)
            .then(res => res.json())
            .then(response => {
                const total = parseInt(response.total);
                const totalPages = Math.ceil(total / perPage);
                setRacesData(racesData.concat(response.data));
                setRacesTotal(total);
                setViewMore(page < totalPages);

                if (page === 1) {
                    if (response.data.length <= 3) {
                        setViewAll(true);
                    }

                    setFirstLoading(false);
                } else {
                    setLoading(false);
                }
            });
    };

    useEffect(() => {
        fetchRacesResults();
    }, [page]);

    const racesDataResults = () => {
        if (!viewAll && page === 1) {
            return racesData.slice(0, 3);
        }

        return racesData;
    };

    const movementCss = result => {
        let baseCssClass = 'database-table__';
        return result.movement > 0 ? `${baseCssClass}up` : `${baseCssClass}down`;
    };

    if (firstLoading) {
        return <Loader />;
    }

    let lastPosition = '';
    let lastVehicle = '';
    let lastNumber = '';
    let lastPoints = '';

    return (
        <div className="database-table-collapsible__table">
            <table className="database-table database-table--striped">
                <thead>
                    <tr className="proxima">
                        <th>Position</th>
                        <th>Driver</th>
                        <th>No.</th>
                        <th>Team</th>
                        <th>Vehicle</th>
                        <th>Time</th>
                        <th>Points</th>
                    </tr>
                </thead>
                <tbody>
                    {racesData.length > 0 &&
                        racesDataResults().map((result, i) => {
                            let repeat = false;
                            if (
                                lastPosition == result.position &&
                                lastVehicle == result.vehicle &&
                                lastNumber == result.driver_number
                            ) {
                                repeat = true;
                            }

                            let showPoints = !repeat || result.points !== lastPoints;

                            lastPosition = result.position;
                            lastVehicle = result.vehicle;
                            lastNumber = result.driver_number;
                            lastPoints = result.points;

                            return (
                                <tr key={i}>
                                    <td className="proxima">
                                        {repeat == false && (
                                            <div className="database-table__group">
                                                <p
                                                    className="database-table__counter"
                                                    dangerouslySetInnerHTML={{ __html: result.position }}></p>
                                                {Math.abs(result.movement) !== 0 && (
                                                    <p className={movementCss(result)}>{Math.abs(result.movement)}</p>
                                                )}
                                            </div>
                                        )}
                                    </td>
                                    <td>
                                        <p className="database-table__title">
                                            <a href={result.driver_url}>{result.driver_name}</a>
                                        </p>
                                    </td>
                                    <td>
                                        {repeat == false && (
                                            <p className="database-table__subtitle database-table__subtitle--black proxim">
                                                {result.driver_number}
                                            </p>
                                        )}
                                    </td>
                                    <td>
                                        {repeat == false && (
                                            <p className="database-table__title">
                                                <a href={result.team_url}>{result.team_name}</a>
                                            </p>
                                        )}
                                    </td>
                                    <td>
                                        {repeat == false && (
                                            <p className="database-table__title database-table__title--regular">
                                                {result.vehicle}
                                            </p>
                                        )}
                                    </td>
                                    <td>
                                        {repeat == false && (
                                            <p className="database-table__subtitle database-table__subtitle--lower database-table__subtitle--black proxima">
                                                {result.race_time}
                                            </p>
                                        )}
                                    </td>
                                    <td>
                                        {showPoints && (
                                            <p className="database-table__subtitle database-table__subtitle--black proxima">
                                                {result.points}
                                            </p>
                                        )}
                                    </td>
                                </tr>
                            );
                        })}
                    {racesData.length < 1 && (
                        <tr>
                            <td colSpan="7">No results available in the database</td>
                        </tr>
                    )}
                </tbody>
            </table>
            {!viewAll && (
                <>
                    <br />
                    { permalink ? (
                        <a href={permalink} className="button button--outline">
                            View all results
                        </a>
                    ) : (
                        <a onClick={() => setViewAll(true)} className="button button--outline">
                            View all results
                        </a>
                    ) }
                </>
            )}
            {permalink && viewAll ? (
                <>
                    <br />
                    <a href={permalink} className="button button--outline">
                        View more
                    </a>
                </>
            ): ''}
            {!loading && !permalink && viewAll && viewMore && (
                <>
                    <br />
                    <a onClick={() => setPage(page + 1)} className="button button--outline">
                        View more
                    </a>
                </>
            )}
            {loading && (
                <>
                    <br />
                    <Loader />
                </>
            )}
        </div>
    );
};

export default RaceResultsTable;
